export const zeroPad = (num: string | number, size: number) => {
  const s = "000000000" + num;
  return s.substr(s.length - size);
};
